class DotLog {
    constructor(config){
      config = config ? config : {};
      this.attr = Object.assign(config, {
        delay: 50,
        eleAttr: "data-log"
      });
      this.init();
    }
  
    get(key) {
      return this.attr[key];
    }
  
    init() {
      this.queues = {};
      this.window = window;
      this.window.addEventListener("scroll", this.onscroll.bind(this));
      this.onscroll();
    }
    onscroll() {
      if (this.scrollTimer) {
        clearTimeout(this.scrollTimer);
      }
      this.scrollTimer = setTimeout(() => {
        if (this.scrollTimer) {
          clearTimeout(this.scrollTimer);
        }
        this.calculate();
        this.sendDot();
      }, this.get("delay"));
    }
  
    calculate() {
      let scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      let scrollBottom = scrollTop + document.documentElement.clientHeight;
      const eleAttr = this.get("eleAttr");
      //检测元素
      let els = document.querySelectorAll("[" + eleAttr + "]") || [];
      for (let i = 0; i < els.length; i++) {
        let el = els[i];
        if (el.style.visibility != "hidden" && el.style.display != "none") {
          let data = JSON.parse(el.getAttribute(eleAttr));
          if (!data["id"] || !data["src"]) {
            console.error("缺少曝光唯一的id标识符");
            return;
          }
          let id = data.id;
          //判断是否在视野区域
          let top = this.getDocumentOffsetTop(el),
            height = el.offsetHeight,
            bottom = top + height,
            inTop = top + height * 0.2,
            inBottom = bottom - height * 0.2;
  
          //添加队列
          if (!this.queues[id]) {
            data.isReady = 0;
            this.queues[id] = data;
          }
          if (inBottom > scrollTop && inTop < scrollBottom) {
            // 避免重复发送
            console.log(scrollTop);
            if (this.queues[id].isReady === 0) {
              this.queues[id].needDot = true;
            }
          } else {
            if (this.queues[id].isReady === 0) {
              this.queues[id].needDot = false;
            }
          }
        }
      }
    }
    getDocumentOffsetTop(el) {
      // el.offsetParent 取最近的ele的父级别元素 定位部位position 不为static 的元素
      if (el.offsetParent != null) {
        let top = this.getDocumentOffsetTop(el.offsetParent);
        return el.offsetTop + top;
      } else {
        return el.offsetTop;
      }
    }
    sendDot() {
      for (let id in this.queues) {
        if (this.queues.hasOwnProperty(id)) {
          let dot = this.queues[id];
          if (dot.isReady === 0 && dot.needDot === true) {
            //发送请求
            console.log("send", dot);
            this.feedback(dot.src, () => {
              dot.isReady = 1;
              dot.needDot = false;
            });
          }
        }
      }
    }
    feedback(url, success) {
      // function callAjax(url, callback) {
      //   var xmlhttp;
      //   // compatible with IE7+, Firefox, Chrome, Opera, Safari
      //   xmlhttp = new XMLHttpRequest();
      //   xmlhttp.onreadystatechange = function() {
      //     if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
      //       callback(xmlhttp.responseText);
      //     }
      //   };
      //   xmlhttp.open("GET", url, true);
      //   xmlhttp.send();
      // }
      var img =new Image();
      img.style.display="none";
      img.src=url;
      document.body.appendChild(img);
      success && success();
      //删除Dom
      setTimeout(function(){
        document.body.removeChild(img);
      },500);
    
      // callAjax(url, success);
  
    }
}

const hoc =  (config)=>{
    if (!window.logSDK) {
        const Dot = new DotLog(config);
        window.logSDK = Dot;
        return Dot;
        e;
      }
      return window.logSDK;
}
window.hocLog = hoc;

export default hoc
  


// WEBPACK FOOTER //
// ./src/realclick.js